import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { color } from '@/themes/color';
import { typography } from '@/themes/typography';

export function SectionTitle({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  return (
    <Typography
      sx={{
        ...typography.heading3,
        color: color.charcoal.default,
        mb: '24px',
        fontFamily: 'Gotham',
        fontWeight: 350,
      }}
    >
      {children}
    </Typography>
  );
}

export function Subsection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <Box sx={{ mb: '24px' }}>
      <Typography
        sx={{
          ...typography.heading5,
          color: color.charcoal.default,
          mb: '12px',
          fontWeight: 350,
        }}
      >
        {title}
      </Typography>
      {typeof children === 'string' ? (
        <BodyText>{children}</BodyText>
      ) : (
        children
      )}
    </Box>
  );
}

export function SubsubsectionTitle({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  return (
    <Typography
      sx={{
        ...typography.bodyText,
        color: color.charcoal.default,
        mt: '16px',
        mb: '8px',
        fontWeight: 350,
        display: 'block',
      }}
    >
      {children}
    </Typography>
  );
}

export function BodyText({ children }: { children: ReactNode }): JSX.Element {
  return (
    <Typography
      sx={{
        ...typography.bodyText,
        color: color.charcoal.default,
        lineHeight: '1.7',
      }}
    >
      {children}
    </Typography>
  );
}

export function DefinitionList({
  items,
}: {
  items: Array<{ term: string; definition: string }>;
}): JSX.Element {
  return (
    <Box>
      {items.map((item) => (
        <Box key={item.term} sx={{ mb: '28px' }}>
          <Typography
            component="span"
            sx={{
              ...typography.bodyText,
              color: color.charcoal.default,
              fontWeight: 350,
            }}
          >
            {item.term}
          </Typography>
          <Typography
            component="span"
            sx={{
              ...typography.bodyText,
              color: color.charcoal.default,
              ml: '8px',
            }}
          >
            {item.definition}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
